import { Component, Inject, OnInit } from '@angular/core';
import { AppMetaDataItemNames, FlightSchoolEntity, ProfitShareTypeAllItems, ProfitSharingTotalsBySchoolQueryEntity } from '../../../../meta-data/app-meta-data.service';
import { DwTileConfig } from '../../../z-devware/visualizations/models/dw-tile-config.model';
import {
  DwConfigServiceToken, DwConfigService, DwSecurityUserService, DwComponent, DwComponentType, DwMetaDataService,
  DwSectionBaseComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfig,
  DwMetaDataFormApi,
  DwUIMetaDataConfigToken, DwMetaDataServiceToken, DwMetaDataFormStateService, DwFormActionInterceptor,
  DwEventService,
  DwOrmDataService
}
  from '@devwareapps/devware-cap';
import { HttpClient } from '@angular/common/http';
import { AdminManagerService } from '../../../admin/services/admin-manager.service';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { PaymentsRepositoryService } from '../../services/payments-repository.service';
import { combineLatest } from 'rxjs';

@DwComponent({
  key: 'school-profit-sharing-details',
  name: 'School Profit Sharing Details',
  componentType: DwComponentType.formSection,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.FlightSchool,
})
@Component({
  selector: 'app-profit-sharing-details',
  templateUrl: './profit-sharing-details.component.html',
  styleUrls: ['./profit-sharing-details.component.scss']
})
export class ProfitSharingDetailsComponent extends DwSectionBaseComponent {

  tileConfigs: DwTileConfig[] = [];
  formApi: DwMetaDataFormApi;
  profitSharingDetails: ProfitSharingTotalsBySchoolQueryEntity[] = [];
  profitSharingRate: number;
  constructor(
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwFormStateService: DwMetaDataFormStateService,
    private dwSecurityUserService: DwSecurityUserService,
    private paymentsRepoSvc: PaymentsRepositoryService,
    private adminManagerService: AdminManagerService,
    private dateTimeUtilService: DateTimeUtilService,
    @Inject(DwConfigServiceToken) private configService: DwConfigService,
    private dwEventService: DwEventService

  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    this.formApi = this.dwFormStateService.state.formApi;
  }

  ngOnInit(): void {
    this.runAfterFormDataLoaded(() => this.setupData());

    this.setupRefresh();
  }

  setupRefresh() {
    this.dwEventService.getEventData(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.Subscription))
      .subscribe(() => {
        this.setupData();
      });
  }

  setupData(): void {
    const flightSchool = this.formApi.getFormData<FlightSchoolEntity>();

    const ob1 = this.paymentsRepoSvc.getProfitSharingRates(flightSchool.FlightSchoolId)
    const ob2 = this.paymentsRepoSvc.getProfitSharingDetails(flightSchool.FlightSchoolId)

    combineLatest([ob1, ob2])
      .subscribe(([profitSharingRate, profitSharingDetails]) => {
        this.profitSharingRate = profitSharingRate;
        this.profitSharingDetails = profitSharingDetails;

        this.setupTiles();
      });
  }

  private setupTiles() {
    const currentMonthDispaly = this.dateTimeUtilService.getCurrentMonthShortDisplay();
    const currentYear = this.dateTimeUtilService.getCurrentYear();

    this.tileConfigs = [];
    this.addManualTileConfig(`${this.profitSharingRate || 0}%`, 'Rate', 'fa fa-percent dw-green');
    this.addTileConfig(ps => ps.Year && !ps.Month, `${currentYear} Total`, 'fa fa-sack-dollar dw-green');
    this.addTileConfig(ps => ps.Year && ps.Month && !ps.ProfitShareTypeId, `${currentMonthDispaly} Total`, 'fa fa-sack-dollar dw-blue');
    this.addTileConfig(ps => ps.Year && ps.Month && ps.ProfitShareTypeId == ProfitShareTypeAllItems.SchoolInvoiceReduction, `${currentMonthDispaly} Reduction`, 'fa fa-hand-holding-usd dw-orange');
    this.addTileConfig(ps => ps.Year && ps.Month && ps.ProfitShareTypeId == ProfitShareTypeAllItems.SchoolPayout, `${currentMonthDispaly} Payout`, 'fa fa-envelope-open-dollar dw-orange');
  }

  private addTileConfig(func: (profitSharingDetail: ProfitSharingTotalsBySchoolQueryEntity) => boolean, title: string, icon?: string, additionalText?: string) {
    const profitSharingDetail = this.profitSharingDetails.find(func);

    let amount = (profitSharingDetail?.Sum || 0);

    let decimals = 0;
    if (amount % 1 !== 0) {
      decimals = 2;
    }

    this.tileConfigs.push({
      containerTitle: title,
      tileText: `$${amount.toFixed(decimals)}`,
      additionalText: additionalText,
      iconClass: icon || 'fa fa-dollar-sign',
    });
  }

  private addManualTileConfig(tileText: string, title: string, icon?: string, additionalText?: string) {
    this.tileConfigs.push({
      containerTitle: title,
      tileText: tileText,
      additionalText: additionalText,
      iconClass: icon || 'fa fa-dollar-sign',
    });
  }

  private AddTileConfigOld(profitSharingDetail: ProfitSharingTotalsBySchoolQueryEntity, titleOverride?: string, tileAdditionalText?: string, iconOveride?: string) {
    let title = profitSharingDetail.ProfitShareType;

    switch (profitSharingDetail.ProfitShareTypeId) {
      case ProfitShareTypeAllItems.SchoolInvoiceReduction:
        title = 'Invoice Reduction';
        break;
      case ProfitShareTypeAllItems.SchoolPayout:
        title = 'Payout';
        break;
    }

    if (!title) {
      if (profitSharingDetail.Month) {
        title = profitSharingDetail.Month.toString();
      } else if (profitSharingDetail.Year) {
        title = profitSharingDetail.Year.toString();
      }
    }

    title = titleOverride ?? title;

    if (title) {
      this.tileConfigs.push({
        containerTitle: title,
        tileText: `$${profitSharingDetail.Sum}`,
        additionalText: tileAdditionalText,
        iconClass: iconOveride || 'fa fa-dollar-sign',
      });
    }

  }

}
